/* jshint esversion: 6 */

import '../../../lib/string';
import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetMessage extends React.Component {
  renderMedia(contents) {
    return contents.map((media) => (
      <img src={media.url} />
    ))
  }
  render() {
    return (
      <div id={this.props.id}
            className={'message-box ' + this.props.direction}
            data-status={this.props.status}
            data-direction={this.props.direction}>
        {this.props.direction === "out" && this.props.username != null &&
          <div className="avatar" aria-hidden="true" >
            {this.props.username.charAt(0).toUpperCase()}
          </div>
        }
        <div className="message-container">
          {this.props.contents &&
            this.renderMedia(this.props.contents)
          }
          {this.props.messageText &&
            <div aria-label={ this.props.direction === "out" ?  (this.props.username != null ? this.props.username + " says" : '') : "I say" } className={this.props.direction + "bound-message"} style={{border: this.props.direction === "in" ? "1px solid " + this.props.primaryColor : ""}}>
              <div
                className="message-text"
                dangerouslySetInnerHTML={this.props.messageText.toReactHtml({ linkify: true })} />
            </div>
          }
          <div aria-hidden="true" className={'chat-timestamp stamp-' + this.props.direction}>
            <span>{this.props.direction === "out" && this.props.username != null ? this.props.username + " - " : ''}</span><time dateTime={new Date(this.props.sentAt).toISOString()} data-local="time" data-format="%m/%d/%Y at %l:%M %P" />
          </div>
        </div>
      </div>
    );
  }
}

WebsiteWidgetMessage.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  direction: PropTypes.string,
  messageText: PropTypes.string,
  status: PropTypes.string,
  sentAt: PropTypes.number,
};

export default WebsiteWidgetMessage;
